<template>
  <el-table-column
    prop="birth_place"
    label="Születési hely"
    sortable="custom"
    min-width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.birth_place || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'birth_place',
  };
</script>
